import React from "react";
import {useDispatch} from "react-redux";
import {getNotifications} from "../states/global";

export const NOTIFICATIONS_POLL_INTERVAL_MS = 100000;

const useNotificationsPolling = () => {
	const dispatch = useDispatch();

	const refreshNotifications = React.useCallback(() => {
		return dispatch(getNotifications());
	}, [dispatch]);

	React.useEffect(() => {
		let isMounted = true;
		let timeoutId = null;

		const poll = async () => {
			await refreshNotifications();

			if (isMounted) {
				timeoutId = setTimeout(poll, NOTIFICATIONS_POLL_INTERVAL_MS);
			}
		};

		poll();

		return () => {
			isMounted = false;
			if (timeoutId !== null) {
				clearTimeout(timeoutId);
			}
		};
	}, [refreshNotifications]);

	return refreshNotifications;
};

export default useNotificationsPolling;
